import React, { createContext, useContext, useState, useCallback } from 'react';
import Notification from '../components/Notification';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export function NotificationProvider({ children }) {
    const [notifications, setNotifications] = useState([]);

    const showNotification = useCallback((message, type = 'info', duration = 600000) => {
        const id = Date.now();
        setNotifications((prev) => [...prev, { id, message, type, duration }]);
    }, []);

    const removeNotification = (id) => {
        setNotifications((prev) => prev.filter((notif) => notif.id !== id));
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            <div className="fixed top-4 right-4 z-50">
                {notifications.map((notif) => (
                    <Notification key={notif.id} {...notif} onClose={removeNotification} />
                ))}
            </div>
        </NotificationContext.Provider>
    );
}
